import { useContext, useEffect } from 'react';
import { StoreContext, isSubscribedAny } from 'store';
import FingerprintJS from '@fingerprintjs/fingerprintjs';


const FingerprintLoader = () => {
  const { state, dispatch } = useContext(StoreContext);

  useEffect(() => {
    const loadVisitorId = async () => {
      const alreadyExists = localStorage.getItem('visitor_id');
      const userSubscribed = isSubscribedAny(state);

      if (userSubscribed && !alreadyExists) {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        localStorage.setItem('visitor_id', result.visitorId);

        dispatch({
          type: 'UPDATE_STATE',
          payload: { visitor_id: result.visitorId }
        });
      }
    };

    setTimeout(function() {
        loadVisitorId();
    }, 2000);
  }, [state]);

  return null;
};

export default FingerprintLoader;
